import { Label } from 'shared/ui/Label'
import { ContactsTrigger } from './ContactsTrigger'
import styles from './styles.module.scss'

export const ContactsContent = () => {
  return (
    <div className={styles.wrap}>
      <Label
        label={{
          text: 'Contacts',
          horizontal: true,
          className: styles.label,
        }}
      />
      <ContactsTrigger />
    </div>
  )
}
